(() => {
  const siteNav = document.querySelector('[data-site-nav]');
  if (siteNav) {
    const threshold = 48;
    const bar = siteNav.querySelector('.site-nav__bar');
    let scrolled = false;
    let theme = 'light';

    const readNavTheme = () => {
      if (!bar) return 'light';
      const rect = bar.getBoundingClientRect();
      const probeY = window.scrollY + rect.top + rect.height / 2;
      let detected = 'light';

      for (const zone of document.querySelectorAll('[data-nav-theme]')) {
        const zoneRect = zone.getBoundingClientRect();
        const top = window.scrollY + zoneRect.top;
        const bottom = top + zoneRect.height;
        if (probeY >= top && probeY < bottom) {
          detected = zone.dataset.navTheme === 'dark' ? 'dark' : 'light';
        }
      }

      return detected;
    };

    const updateNav = () => {
      const nextScrolled = window.scrollY > threshold;
      const nextTheme = readNavTheme();

      if (nextScrolled !== scrolled) {
        scrolled = nextScrolled;
        siteNav.classList.toggle('is-scrolled', scrolled);
      }

      if (nextTheme !== theme) {
        theme = nextTheme;
        siteNav.classList.toggle('is-nav-dark', theme === 'dark');
        siteNav.classList.toggle('is-nav-light', theme === 'light');
      }
    };

    updateNav();
    window.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav, { passive: true });
  }

  const clinical = document.querySelector('[data-clinical-section]');
  if (clinical && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) clinical.classList.add('is-visible');
    }, { threshold: 0.35 }).observe(clinical);
  }

  const hero = document.querySelector('[data-hero-carousel]');
  if (hero) {
    const gradients = [...hero.querySelectorAll('[data-hero-gradient]')];
    const navItems = [...hero.querySelectorAll('[data-hero-dot]')];
    const flavorCount = gradients.length;

    if (flavorCount > 0) {
      let current = 0;
      let timer = null;
      const intervalMs = Math.max(3000, parseInt(hero.dataset.heroInterval || '5', 10) * 1000);

      const showFlavor = (index) => {
        current = (index + flavorCount) % flavorCount;
        gradients.forEach((el, i) => el.classList.toggle('is-active', i === current));
        navItems.forEach((el, i) => {
          el.classList.toggle('is-active', i === current);
          el.setAttribute('aria-selected', i === current ? 'true' : 'false');
        });
        hero.dispatchEvent(new CustomEvent('stack-hero-flavor', { detail: { index: current } }));
      };

      const startTimer = () => {
        clearInterval(timer);
        if (flavorCount > 1 && !hero.dataset.handoffActive) {
          timer = setInterval(() => showFlavor(current + 1), intervalMs);
        }
      };

      hero.addEventListener('stack-hero-handoff', (e) => {
        if (e.detail?.active) {
          hero.dataset.handoffActive = 'true';
          clearInterval(timer);
          if (typeof e.detail.flavorIndex === 'number') showFlavor(e.detail.flavorIndex);
        } else {
          delete hero.dataset.handoffActive;
          startTimer();
        }
      });

      navItems.forEach((item) => {
        item.addEventListener('click', () => {
          showFlavor(parseInt(item.dataset.heroDot, 10));
          startTimer();
        });
      });

      showFlavor(0);
      startTimer();
    }
  }
})();